// Each service can carry an optional `startingPrice` — shown as
// "Starting from ₹XX,XXX" in ServiceShowcase when present.
const services = [
  {
    slug: "wedding-planning",
    title: "Wedding Planning",
    description:
      "End-to-end planning and vendor curation, so every celebration runs as gracefully as it looks.",
    image: "/images/services/wedding-planning.webp",
    startingPrice: "₹75,000",
  },
  {
    slug: "wedding-decor",
    title: "Wedding Décor",
    description:
      "Full-scale décor design — from floral architecture to fabric, lighting and every finishing detail in between.",
    image: "/images/services/wedding-decor.webp",
    startingPrice: "₹1,20,000",
  },
  {
    slug: "mandap-design",
    title: "Mandap Design",
    description:
      "From traditional elegance to contemporary luxury, we create mandaps designed around your celebration.",
    image: "/images/services/mandap-design.webp",
    startingPrice: "₹85,000",
  },
  {
    slug: "stage-decoration",
    title: "Stage Decoration",
    description:
      "Sculptural backdrops in fabric, floral and light — built to anchor every key ceremony moment.",
    image: "/images/services/stage-decoration.webp",
    startingPrice: "₹60,000",
  },
  {
    slug: "floral-design",
    title: "Floral Design",
    description:
      "Hand-tied garlands, floating installations and seasonal blooms sourced and composed in-house.",
    image: "/images/services/floral-design.webp",
    startingPrice: "₹45,000",
  },
  {
    slug: "reception-styling",
    title: "Reception Styling",
    description:
      "Tablescapes, staging and lighting composed for how a reception actually moves — and photographs.",
    image: "/images/services/reception-styling.webp",
    startingPrice: "₹95,000",
  },
  {
    slug: "lighting-ambience",
    title: "Lighting & Ambience",
    description:
      "Warm, low, considered light — diyas, lanterns and fire bowls in place of anything that feels like an event.",
    image: "/images/services/lighting-ambience.webp",
    startingPrice: "₹35,000",
  },
  {
    slug: "entrance-decor",
    title: "Entrance Décor",
    description:
      "The first impression of the day — floral arches, brass urns and welcome installations at the gate.",
    image: "/images/services/entrance-decor.webp",
    startingPrice: "₹30,000",
  },
  {
    slug: "table-styling",
    title: "Table Styling",
    description:
      "Linen, tableware, florals and place settings composed as carefully as the rest of the room.",
    image: "/images/services/table-styling.webp",
    startingPrice: "₹25,000",
  },
  {
    slug: "photography-coordination",
    title: "Photography Coordination",
    description:
      "We work directly with your photography team to plan light, timing and vantage points in advance.",
    image: "/images/services/photography-coordination.webp",
    startingPrice: null,
  },
  {
    slug: "destination-wedding-planning",
    title: "Destination Wedding Planning",
    description:
      "From Kerala to Goa and beyond — full logistics, local sourcing and design built for the setting.",
    image: "/images/services/destination-wedding-planning.webp",
    startingPrice: "₹2,00,000",
  },
];

export default services;
